import $ from 'jquery';

const initMobileMenu = () => {
    const $body = $('body');
    const $desktop = $('.s-desktop-header');
    $desktop.removeClass('hidden');
    const $menuHeight = $('.c-desktop-menu').outerHeight();

    if ($menuHeight > 40 || $menuHeight === 0) {
        $body.addClass('mobile-menu');
        $body.removeClass('desktop-menu');
    } else {
        $body.addClass('desktop-menu');
        $body.removeClass('mobile-menu');
    }
};

$(() => {
    initMobileMenu();

    $(window).on('resize', () => {
        initMobileMenu();
    });
});



// WEBPACK FOOTER //
// ./src/sections/mobile-header/s-mobile-header.js